/** Espelha `CampoNativoEnum` da API Compras: campos nativos do card que a etapa pode tornar obrigatórios. */
export enum CampoNativoEnum {
  Prioridade = 1,
  Solicitante = 2,
  Setor = 3,
  EntregaDesejada = 4,
  Justificativa = 5,
  Fornecedor = 6,
  ValorTotal = 7,
  CondicaoPagamento = 8,
}
